export default "__VITE_ASSET__DGOeIfSH__"